class ResponseStore {
  constructor () {
    this.state = {
      processing: false
    };
  }

  startProcessing () {
    this.state.processing = true;
  }

  finishProcessing () {
    this.state.processing = false;
  }
}

export default new ResponseStore();
